import React from 'react';
import cx from 'classnames';
import { Reveal } from 'react-reveal';

import Blockquotes from './assets/blockquotes.svg';
import CrushTheGRELogo from './assets/crush_the_gre_logo.png';
import StarIcon from './assets/star_icon.svg';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className={cx(styles.socialProofContainer, 'd-flex flex-column gap-m')}>
      <div className="text-center">
        <img alt="" src={Blockquotes} />
      </div>

      <Reveal duration={1000} effect={marketingStyles.fadeInAndSlideUp}>
        <div className="text-bold text-center text-inter" style={{ fontSize: 24 }}>
          "Magoosh gets rave reviews from students, many of whom have improved their GRE score with this flexible and affordable plan."
        </div>
      </Reveal>

      <div className="align-items-center d-flex gap-m justify-content-center">
        <div>
          <img
            alt="Crush the GRE logo"
            height="32px"
            src={CrushTheGRELogo}
            width="146px"
          />
        </div>

        <div style={{ background: '#EDEDED', height: 15, width: 1 }} />

        <div className="align-items-center d-flex gap-xs">
          <div className="small">
            <strong>5</strong> out of 5
          </div>

          <img
            alt="Star icon"
            height="20px"
            src={StarIcon}
            width="20px"
          />
        </div>
      </div>
    </div>
  );
};
